import axios from "axios";
import store from "@/store";
//
const baseURL =
  process.env.VUE_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? "https://api.dev.uchet.twowaysout.monster/api/admin" : "http://localhost:3000/api/admin");

const request = axios.create({
  baseURL,
  withCredentials: true
  // timeout: 10000
});

// Раньше токен читался из localStorage ОДИН раз, в момент загрузки этого
// модуля, и записывался в headers как статическое значение при
// axios.create() — если на этот момент пользователь ещё не залогинен
// (обычная ситуация: этот файл импортируется в самом начале работы
// приложения), token навсегда остаётся undefined в этом инстансе. Login.vue
// после входа делает localStorage.setItem + router.push БЕЗ полной
// перезагрузки страницы — модуль не переисполняется, так что все запросы до
// следующей перезагрузки страницы летели без токена: бэкенд не находил
// пользователя и слал 302 на "/", а там 404 "Cannot GET /" — ровно то, что
// видно в консоли сразу после логина, и ровно почему обычная перезагрузка
// уже залогиненной страницы "чинит" всё (модуль переисполняется заново,
// на этот раз token в localStorage уже есть).
request.interceptors.request.use(config => {
  const auth = localStorage.getItem("Auth");
  if (auth) {
    try {
      config.headers.token = JSON.parse(auth).token;
    } catch (error) {
      // ignore malformed localStorage.Auth, request goes out without a token
    }
  }
  return config;
});

const authRequest = axios.create({ baseURL, withCredentials: true });
//
const getError = error => {
  const message =
    (error.response && error.response.data && error.response.data.message) ||
    "Ошибка запроса";
  alert(message);
};
//
export function getValuteCategories() {
  return request.get(`/valute-categories`).catch(getError);
}

// ledger exchanges
export function getLedgerExchanges(params = {}) {
  return request.get("/ledgerExchanges", {
    params: {
      ...params,
      // populate: ["ledgerTransactions", "creator"],
      populate: {
        path: "ledgerTransactions creator",
        populate: {
          path: "balanceAccount",
          populate: {
            path: "valute"
          }
        }
      }
    }
  });
}
export function getLedgerExchangesCsv(params = {}) {
  return request.get(
    "/ledgerExchanges/csv",
    // {
    //   params: {
    //     ...params,
    //     populate: ["ledgerTransactions", "creator"],
    //     lean: true
    //   }
    // }
    {
      params: {
        ...params,
        populate: {
          path: "ledgerTransactions creator",
          populate: {
            path: "balanceAccount",
            populate: {
              path: "valute"
            }
          }
        },
        lean: true
      }
    }
  );
}
//TODO: This is unused, feel free to remove
export function getWbRatesCsv(params = {}) {
  return request.get("/ledgerExchanges/wbratescsv");
}
export function getRatesCsv(params = {}) {
  return request.get("/ledgerExchanges/ratescsv", { params });
}
export function getLedgerExchange(id) {
  return request.get(`/ledgerExchanges/${id}`);
}
export function getFullLedgerExchange(id) {
  return request.get(`/ledgerExchanges/full/${id}`);
}
export const editLedgerExchange = (id, data) => {
  return request.put(`/ledgerExchanges/${id}`, data);
};
export const addLedgerExchange = data => {
  return request.post("/ledgerExchanges", data);
};
export function getBinanceRate(incode, outcode) {
  return request.get(`/ledgerExchanges/rate/${incode}/${outcode}`);
}
export function getCsvRatesForDate(date) {
  return request.get(`/ledgerExchanges/csv-rates-for-date/${date}`);
}

// balance accounts
export function getBalanceAccounts(params = {}) {
  return request.get("/ledgerBalanceAccounts", {
    params: {
      ...params,
      // populate: "valute credential exchange exchange.creator"
      // populate: ["valute", "credential", "exchange.creator"]
      populate: {
        path: "valute credential exchange group",
        populate: {
          path: "creator ledgerTransactions"
        }
      }
      // { path: "valute" },
      // { path: "credential" }
    }
  });
}
export function getBalanceAccountsCsv(params = {}) {
  return request.get("/ledgerBalanceAccounts/csv", {
    params: {
      ...params,
      populate: {
        path: "valute exchange"
      },
      lean: true
    }
  });
}
export const getAllBalances = data => {
  return request.post("/ledgerBalanceAccounts/allbalances", data);
};
export const addBalanceAccount = data => {
  return request.post("/ledgerBalanceAccounts", data);
};
export function editUsedForAutoExchangeBalanceAccount(id, data) {
  return request.post(
    `/ledgerBalanceAccounts/setUsedForAutoExchange/${id}`,
    data
  );
}
export function editBalanceAccountGroup(id, data) {
  return request.post(`/ledgerBalanceAccounts/addToGroup/${id}`, data);
}
export function deleteBalanceAccount(id) {
  return request.delete(`/ledgerBalanceAccounts/${id}`);
}
export function editBalanceAccount(id, data) {
  return request.put(`/ledgerBalanceAccounts/${id}`, data);
}

// BalanceAccountGroups
export function getBalanceAccountGroups(params = {}) {
  return request.get("/ledgerBalanceAccountGroups", {
    params: {
      ...params
    }
  });
}
// export function getBalanceAccountGroup(id) {
//   return request.get(`/ledgerBalanceAccountGroups/${id}`);
// }
export const addBalanceAccountGroup = data => {
  return request.post("/ledgerBalanceAccountGroups", data);
};
// export const editBalanceAccountGroup = (id, data) => {
//   return request.put(`/ledgerBalanceAccountGroups/${id}`, data);
// };
export function deleteBalanceAccountGroup(id) {
  return request.delete(`/ledgerBalanceAccountGroups/${id}`);
}

// credentials
export function getCredentials(params = {}) {
  return request.get("/ledgerCredentials", {
    params: {
      ...params
    }
  });
}
export const addCredential = data => {
  return request.post("/ledgerCredentials", data);
};
export const testBitzlato = data => {
  return request.post("/ledgerCredentials/testbitzlato", data);
};
export const testWhitebit = data => {
  return request.post("/ledgerCredentials/testwhitebit", data);
};
export const testFirekassa = data => {
  return request.post("/ledgerCredentials/testfirekassa", data);
};
export const testVanilapay = data => {
  return request.post("/ledgerCredentials/testvanilapay", data);
};
export const testOkx = data => {
  return request.post("/ledgerCredentials/testokx", data);
};
export const getBitzlatoWallet = data => {
  return request.post("/ledgerCredentials/getbitzlatowallet", data);
};
export const getWhitebitWallet = data => {
  return request.post("/ledgerCredentials/getwhitebitwallet", data);
};
export const getFirekassaWallet = data => {
  return request.post("/ledgerCredentials/getfirekassawallet", data);
};
export const getVanilapayWallet = data => {
  return request.post("/ledgerCredentials/getvanilapaywallet", data);
};
export const getOkxWallet = data => {
  return request.post("/ledgerCredentials/getokxwallet", data);
};
export function deleteCredential(id) {
  return request.delete(`/ledgerCredentials/${id}`);
}
// ledger BI
// Без .catch(getError) намеренно: эти запросы дергаются фоновым опросом
// дашборд-виджетов, а не по клику пользователя, так что alert() тут неуместен —
// ошибку обрабатывает сам виджет (иконка/текст), а не всплывающее окно.
export function getLedgerBiTotal() {
  return request.get("/ledgerBi");
}
export function getLedgerBiToday() {
  return request.get("/ledgerBi/todayAvg");
}
export function getLedgerBiTotalInRub() {
  return request.get("/ledgerBi/totalBalanceInRub");
}
// dashboards
export function getDashboardElements(params = {}) {
  return request.get("/ledgerDashboards", {
    params: {
      ...params
    }
  });
}
export const addDashboardElement = data => {
  return request.post("/ledgerDashboards", data);
};
export function deleteDashboardElement(id) {
  return request.delete(`/ledgerDashboards/${id}`);
}
export function reorderDashboardElements(ids) {
  return request.put("/ledgerDashboards/reorder", { ids });
}

// ledger valutes
export function getLedgerValutes(params = {}) {
  return request.get("/ledgerValutes", {
    params: {
      ...params
    }
  });
}
export const addLedgerValute = data => {
  return request.post("/ledgerValutes", data);
};
export const editLedgerValute = (id, data) => {
  return request.put(`/ledgerValutes/${id}`, data);
};
export function deleteLedgerValute(id) {
  return request.delete(`/ledgerValutes/${id}`);
}

// ledger transactions
export function getLedgerTransactions(params = {}) {
  return request.get("/ledgerTransactions", {
    params: {
      ...params
    }
  });
}
export function getLedgerTransactionsStats(params = {}) {
  return request.get("/ledgerTransactions/stats", {
    params: {
      ...params
    }
  });
}
export function getLedgerTransactionsVerify(params = {}) {
  return request.get("/ledgerTransactions/verify", {
    params: {
      ...params
    }
  });
}
export function reconcileLedgerTransactions(balanceAccount) {
  return request.post("/ledgerTransactions/reconcile", { balanceAccount });
}

export function getNotifications(params = {}) {
  return request.get("/notifications", {
    params: {
      ...params
    }
  });
}
export function getUnreadNotificationsCount() {
  return request.get("/notifications/unreadCount");
}
export function markAllNotificationsRead() {
  return request.post("/notifications/markAllRead");
}

export function getCommissionPresets(params = {}) {
  return request.get("/commissionPresets", { params });
}
export function createCommissionPreset(data) {
  return request.post("/commissionPresets", data);
}
export function updateCommissionPreset(id, data) {
  return request.put(`/commissionPresets/${id}`, data);
}
export function deleteCommissionPreset(id) {
  return request.delete(`/commissionPresets/${id}`);
}

export function getProjects(params = {}) {
  return request.get("/projects", {
    params: {
      ...params
    }
  });
}

export function deleteProjects(id) {
  return request.delete(`/projects/${id}`);
}

export const updateProjectsRow = data => {
  console.log("data =", data._id);
  return request.put(`/projects/${data._id}`, data);
};

export const updateSourceTypeRow = data => {
  console.log("data up =", data);
  return request.put(`/sourcetypes/${data._id}`, data);
};
export function getSourceTypes(params = {}) {
  return request.get("/sourcetypes", {
    params: {
      ...params
    }
  });
}
export const addSourceType = data => {
  return request.post("/sourcetypes", data);
};

export const addProject = data => {
  return request.post("/projects", data);
};

export function deleteSourceType(id) {
  return request.delete(`/sourcetypes/${id}`);
}
//ValuteCity
export const updateValuteCityRow = data => {
  console.log("data up =", data);
  return request.put(`/valute-city/${data._id}`, data);
};
export function getValuteCities(params = {}) {
  return request.get("/valute-city", {
    params: {
      ...params
    }
  });
}
export function getValuteCityBasicCommission() {
  return request.get("/valute-city/basic-commission/");
}
export const addValuteCity = data => {
  return request.post("/valute-city", data);
};
export function deleteValuteCity(id) {
  return request.delete(`/valute-city/${id}`);
}
// sites
export function getSites(params = {}) {
  return request.get("/sites", {
    params: {
      ...params
    }
  });
}
export const addSite = data => {
  return request.post("/sites", data);
};
export const editSite = (id, data) => {
  return request.put(`/sites/${id}`, data);
};
export function deleteSite(id) {
  return request.delete(`/sites/${id}`);
}

// api users
export function getApiUsers(params = {}) {
  return request.get("/apiusers", {
    params: {
      ...params
    }
  });
}
export function getApiUser(id) {
  return request.get(`/apiusers/${id}`);
}
export const addApiUser = data => {
  return request.post("/apiusers", data);
};
export const editApiUSer = (id, data) => {
  return request.put(`/apiusers/${id}`, data);
};
export function deleteApiUser(id) {
  return request.delete(`/apiusers/${id}`);
}

// rtapi cards
export function getCards(params = {}) {
  return request.get("/cards", {
    params: {
      ...params
    }
  });
}
export function getCard(id) {
  return request.get(`/cards/${id}`);
}
export const addCard = data => {
  return request.post("/cards", data);
};
export const editCard = (id, data) => {
  return request.put(`/cards/${id}`, data);
};
export function deleteCard(id) {
  return request.delete(`/cards/${id}`);
}

// trade pairs
export function getTradePairs() {
  return request.get("/trade-pairs");
}
export function deleteTradePair(id) {
  return request.delete(`/trade-pairs/${id}`);
}
export function editTradePair(data) {
  return request.put("/trade-pairs", data);
}

export function addTradePair(data) {
  return request.post("/trade-pairs", data);
}

// valutes
export function getValutes() {
  return request.get(`/valutes`).catch(getError);
}

export function queryPaginationValutes(query) {
  return request
    .get(`/valutes/query-pagination`, { params: { ...query } })
    .catch(getError);
}
// То же самое, но без alert() на ошибке — используется фоновым опросом
// дашборд-виджетов (курсовые карточки), где alert() был бы неуместен.
// Основной queryPaginationValutes не трогаем — от него зависит страница Валют.
export function queryPaginationValutesQuiet(query) {
  return request.get(`/valutes/query-pagination`, { params: { ...query } });
}

export function queryPaginationCrossRates(query) {
  return request
    .get(`/cross-rate/query-pagination`, { params: { ...query } })
    .catch(getError);
}

export function deleteCrossRate(id) {
  return request.delete(`/cross-rate/${id}`).catch(getError);
}

export async function getCrossRate(id) {
  return await request.get(`/cross-rate/${id}`);
}

export async function addCrossRate(data) {
  return await request.post("/cross-rate", data);
}

export async function editCrossRate(data) {
  return await request.put("/cross-rate", data);
}
export async function calculateCrossRate(data) {
  return await request.post("/cross-rate/calculateBestchange", data);
}

export function addValute(data) {
  let form = new FormData();
  //
  Object.keys(data).map(key => {
    form.append(key, data[key]);
  });
  //
  return request.post(`/valutes`, form).catch(getError);
}

export function editValute(id, data) {
  let form;
  //
  if (data.image && typeof data.image === "object") {
    form = new FormData();
    //
    Object.keys(data).map(key => {
      form.append(key, data[key]);
    });
  } else {
    form = data;
    delete form.image;
  }
  //
  return request.post(`/valutes/${id}`, form).catch(getError);
}

export function deleteValute(id) {
  return request.delete(`/valutes/${id}`).catch(getError);
}

export function getValuteForms(id) {
  return request.get(`/valutes/${id}/forms`).catch(getError);
}

export function addValuteForm(id, data) {
  return request.post(`/valutes/${id}/forms`, data).catch(getError);
}

export function editValuteForm(id, formId, data) {
  return request.post(`/valutes/${id}/forms/${formId}`, data).catch(getError);
}

export function deleteValuteForm(id, formId) {
  return request.delete(`/valutes/${id}/forms/${formId}`).catch(getError);
}
// wallets
export function getWallets() {
  return request.get(`/wallets`).catch(getError);
}

export function addWallet(data) {
  return request.post(`/wallets`, data).catch(getError);
}

export function editWallet(id, data) {
  return request.post(`/wallets/${id}`, data).catch(getError);
}

export function deleteWallet(id, data) {
  return request.delete(`/wallets/${id}`, data).catch(getError);
}

export function getWalletForms(id) {
  return request.get(`/wallets/${id}/forms`).catch(getError);
}

export function addWalletForm(id, data) {
  return request.post(`/wallets/${id}/forms`, data).catch(getError);
}

export function editWalletForm(id, formId, data) {
  return request.post(`/wallets/${id}/forms/${formId}`, data).catch(getError);
}

export function deleteWalletForm(id, formId) {
  return request.delete(`/wallets/${id}'/forms/${formId}`).catch(getError);
}
// users
export function getUsers() {
  return request.get(`/users`).catch(getError);
}
export async function getUsersSuggest(q) {
  try {
    return await request.get(`/users/suggest`, { params: { q } });
  } catch (error) {
    return getError(error);
  }
}
export async function getUserBalanceHistory(id) {
  try {
    return await request.get(`/users/user-balance-history/${id}`);
  } catch (error) {
    return getError(error);
  }
}
export async function queryUsers(query) {
  try {
    return await request.get(`/users/query`, { params: { query } });
  } catch (error) {
    return getError(error);
  }
}
export async function queryPaginationUsers(query) {
  try {
    return await request.get(`/users/query-pagination`, {
      params: { ...query }
    });
  } catch (error) {
    return getError(error);
  }
}

export async function editUser(id, data) {
  try {
    return await request.post(`/users/${id}`, data);
  } catch (error) {
    return getError(error);
  }
}

// payments
export function getVanilaTransaction(paymentId) {
  //
  return request
    .get(`/payments/vanila/transaction/${paymentId}`)
    .catch(getError);
}

// transactions
export function getTransactions(params) {
  params = params || {};
  params = Object.keys(params)
    .map(key => `${key}=${encodeURIComponent(params[key])}`)
    .join("&");
  //
  return request
    .get(`/transactions${!!params ? "?" + params : ""}`)
    .catch(getError);
}

export function getTransactionsCsv(params = {}) {
  return request.get(
    "/transactions/csv",
    // {
    //   params: {
    //     ...params,
    //     populate: ["ledgerTransactions", "creator"],
    //     lean: true
    //   }
    // }
    {
      params: {
        ...params,
        lean: true
      }
    }
  );
}

export function getTransactionById(id) {
  return request.get(`/transactions/${id}`).catch(getError);
}

export function getTransactionsWithEmailCsv() {
  return request.get(`/transactions/withemails`).catch(getError);
}

export async function queryTransactions(query) {
  try {
    return await request.get(`/transactions/query-pagination`, {
      params: { ...query }
    });
  } catch (error) {
    return getError(error);
  }
}

export function editTransaction(id, data) {
  return request.post(`/transactions/${id}`, data).catch(getError);
}

export function deleteTransaction(id) {
  return request.delete(`/transactions/${id}`).catch(getError);
}
// info
export function getInfo() {
  return request.get("/info").catch(getError);
}

export function updateInfo(body) {
  return request.post("/info", body).catch(getError);
}
// parser
export function getParse() {
  return request.get("/parse").catch(getError);
}

export function addParse(body) {
  return request.post("/parse", body).catch(getError);
}

export function editParse(id, body) {
  return request.post("/parse/" + id, body).catch(getError);
}

export function deleteParse(id) {
  return request.delete("/parse/" + id).catch(getError);
}
// Reserve
export function getReserve() {
  return request.get("/reserve").catch(getError);
}

export function addReserve(body) {
  return request.put("/reserve", body).catch(getError);
}

export function editReserve(body) {
  return request.post(`/reserve/${body._id}`, body).catch(getError);
}

export function deleteReserve(id) {
  return request.delete(`/reserve/${id}`).catch(getError);
}
// Outputs
export function getOutputs() {
  return request.get(`/outputs`).catch(getError);
}

export function editOutput(id, data) {
  delete data._id;
  //
  return request.post(`/outputs/${id}`, data).catch(getError);
}
// Reviews
export function getReviews() {
  return request.get(`/reviews`).catch(getError);
}

export function addReview(data) {
  return request.post(`/reviews`, data).catch(getError);
}

export function deleteReview(id) {
  return request.delete(`/reviews/${id}`).catch(getError);
}
//
export function checkToken(token) {
  return request.post(`/check-token`, { token });
}
//
export function saveVerifiedCard(cardNumber) {
  return request.post(`/bankCards`, { cardNumber });
}
//
export function getWhitebitAssets() {
  return request.get(`/info/whitebitAssets`);
}
//
export function loginAdmin(login, password) {
  return authRequest.post(`/auth/login`, { login, password });
}
//
export function changeAdminPassword(token, newPassword) {
  return authRequest.post(`/auth/change-password`, { newPassword }, { headers: { token } });
}



// WEBPACK FOOTER //
// ./src/api/index.js